export const environment = {
  production: true,
  domain: "https://fbooking.dk/",
  apiUrl: "https://fbooking.dk/api",
  apiUrlBI: "https://server.fdbooking.dk/api",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts